export default "__VITE_ASSET__uO81lJgo__"